// TODO this needs to be better integrated with environment CI/CD
import { Api } from '../../../utils/index.js';
import { RetailerPartnerType } from '../enum/index.js';
export const baseEndpoint = `${Api.PRODUCTS}/v1/integrations/`;
export const offersEndpoints = {
    [RetailerPartnerType.NONE]: '',
    [RetailerPartnerType.WALMART]: `${baseEndpoint}wmt/offers`,
    [RetailerPartnerType.KROGER]: `${baseEndpoint}kro/offers`,
    [RetailerPartnerType.TARGET]: `${baseEndpoint}tgt/offers`
};
export const offersBundleEndpoints = {
    [RetailerPartnerType.NONE]: '',
    [RetailerPartnerType.WALMART]: `${baseEndpoint}wmt/bundle/offers`,
    [RetailerPartnerType.KROGER]: `${baseEndpoint}kro/bundle/offers`,
    [RetailerPartnerType.TARGET]: `${baseEndpoint}tgt/bundle/offers`
};
export const locationEndpoints = {
    [RetailerPartnerType.NONE]: '',
    [RetailerPartnerType.WALMART]: `${baseEndpoint}wmt/locations`,
    [RetailerPartnerType.KROGER]: `${baseEndpoint}kro/locations`,
    [RetailerPartnerType.TARGET]: `${baseEndpoint}tgt/locations`
};
export const logosEndpoint = `${baseEndpoint}retailer/search`;
export const retailersOffersEndpoint = `${baseEndpoint}retailers/offers`;
// Example: https://live.polaris.me/api/products/v1/integrations/retailers/offers?zip=98155
// Unified Cart API `/api/products/v1/integrations/retailers/cart`
export const cartEndpoint = '/api/products/v1/integrations/retailers/cart';
